// HouseHoldFilter.jsx
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import DashboardSearchFilters from "../../common/DashboardSearchFilters";
import { fetchData } from "../../../utils/functions";
import {
  setFloodCardCount,
  setHygeineCardCount,
  setWaterCardCount,
  setToiletCardCount,
  setHandWashGraphCount,
  setFloodImpactGraphCount,
  setWaterGraphCount,
  setHouseHoldCompleteCount,
  setAllBeneficiariesCount,
  setHouseHoldCount,
  setvillageCount,
  setMartialStatusCount,
  setGenderStatusCount,
  setEducationCount,
  setFamilySizeCount,
  setAgeGroupCount,
  setToiletGraphCount,
} from "../../../slices/dashboardSlice";

const HouseHoldFilter = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleApplyFilters = async (filters) => {
    try {
      const dashboardRes = await fetchData(
        "dashboard-card-count",
        "GET",
        null,
        filters,
        {},
        navigate,
        "/dashboard-card-count",
        dispatch
      );

      dispatch(setvillageCount(dashboardRes?.data?.villageCount || 0));
      dispatch(
        setHouseHoldCount(dashboardRes?.data?.householdInformationCount || 0)
      );
      dispatch(
        setHouseHoldCompleteCount(
          dashboardRes?.data?.completedHouseholdCount || 0
        )
      );
      dispatch(
        setAllBeneficiariesCount(dashboardRes?.data?.totalBeneficiaries || 0)
      );

      const maritalRes = await fetchData(
        "household-age-group-distribution",
        "GET",
        null,
        filters,
        {},
        navigate,
        "/household-age-group-distribution",
        dispatch
      );
      dispatch(setMartialStatusCount(maritalRes?.data?.maritalStatus || 0));

      const genderRes = await fetchData(
        "get-approved-household-gender-stats",
        "GET",
        null,
        filters,
        {},
        navigate,
        "/get-approved-household-gender-stats",
        dispatch
      );
      dispatch(setGenderStatusCount(genderRes?.data || 0));

      const educationRes = await fetchData(
        "household-age-group-distribution",
        "GET",
        null,
        filters,
        {},
        navigate,
        "/household-age-group-distribution",
        dispatch
      );
      dispatch(
        setEducationCount(educationRes?.data?.noEducationByGenderAgeGroup || 0)
      );

      const familyRes = await fetchData(
        "household-age-group-distribution",
        "GET",
        null,
        filters,
        {},
        navigate,
        "/household-age-group-distribution",
        dispatch
      );
      dispatch(setFamilySizeCount(familyRes?.data?.familySizeGroup || 0));

      const ageRes = await fetchData(
        "household-age-group-distribution",
        "GET",
        null,
        filters,
        {},
        navigate,
        "/household-age-group-distribution",
        dispatch
      );
      dispatch(setAgeGroupCount(ageRes?.data?.ageGroup || 0));

      const floodRes = await fetchData(
        "flood-impact-stats",
        "GET",
        null,
        filters,
        {},
        navigate,
        "/flood-impact-stats",
        dispatch
      );
      dispatch(setFloodCardCount(floodRes?.data || 0));

      const waterRes = await fetchData(
        "water-access-stats",
        "GET",
        null,
        filters,
        {},
        navigate,
        "/water-access-stats",
        dispatch
      );
      dispatch(setWaterCardCount(waterRes?.data || 0));

      const toiletRes = await fetchData(
        "toilet-availability-stats",
        "GET",
        null,
        filters,
        {},
        navigate,
        "/toilet-availability-stats",
        dispatch
      );
      dispatch(setToiletCardCount(toiletRes?.data || 0));

      const hygieneRes = await fetchData(
        "hygiene-practice-stats",
        "GET",
        null,
        filters,
        {},
        navigate,
        "/hygiene-practice-stats",
        dispatch
      );
      dispatch(setHygeineCardCount(hygieneRes?.data || 0));

      dispatch(setToiletGraphCount(toiletRes?.data?.graphData || 0));
      dispatch(setWaterGraphCount(waterRes?.data?.graphData || 0));
      dispatch(setHandWashGraphCount(hygieneRes?.data?.handwashGraph || 0));
      dispatch(setFloodImpactGraphCount(floodRes?.data?.impactGraph || 0));

    } catch (error) {
      console.error("Error applying household filters:", error);
    }
  };

  return (
    <div className="my-4 w-full">
      <DashboardSearchFilters
        accordionTitle="Filters"
        defaultExpanded={false}
        fetchOnChange={false} 
        apiRoutes={{
          districts: "districts",
          tehsils: "tehsils",
          ucs: "ucs",
          dehs: "dehs",
          villages: "villages",
        }}
        dateFields={["date_of_interview"]}
        onApply={handleApplyFilters}
      />
    </div>
  );
};

export default HouseHoldFilter;
